import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_78a5y9jxe7: FaireBrandEntity = {
  token: "b_78a5y9jxe7",
  type: "brand",
  name: "Glowiss",
  avatarUrl:
    "https://cdn.faire.com/fastly/80117cb90cd621ab8b6425f5db3f8a1376b64d5a71cee8404a409ea4fe996a4a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f525567eb4d32e714cd28b30c3328afd52b7b088ed52c46c92baeedfdaf71834.png",
  logoUrl:
    "https://cdn.faire.com/fastly/80117cb90cd621ab8b6425f5db3f8a1376b64d5a71cee8404a409ea4fe996a4a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f525567eb4d32e714cd28b30c3328afd52b7b088ed52c46c92baeedfdaf71834.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 85,
  isTopShop: true,
  isInsider: true,
  description:
    "Glowiss LLC is a company that wholesales popular Korean beauty products. With 10 years of wholesale experience in Seoul, South Korea, we are starting off fresh in Los Angeles, California. Here we are dedicated to bring you the most innovative and trendy Korean beauty hot items at the lowest price to maximize your profit! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:45.533Z",
    importedBy: "entity-db-cli",
  },
};
